import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { ConfirmCancelModal } from '@/shared/components/ConfirmCancelModal'
import { confirmationBodySx } from '@/shared/components/confirmation/confirmationModalStyles'

export const HIDE_QUESTION_DIALOG_TITLE = 'Hide Question?'
export const HIDE_QUESTION_DIALOG_BODY =
  'If you hide this question, it will not be visible in dashboards and reports. Responses will still be collected and stored in our database for future use.'

type Props = Readonly<{
  open: boolean
  onCancel: () => void
  onConfirm: () => void
}>

export function HideQuestionDialog({ open, onCancel, onConfirm }: Props) {
  return (
    <ConfirmCancelModal
      open={open}
      onStay={onCancel}
      onConfirm={onConfirm}
      iconVariant="info"
      headline={HIDE_QUESTION_DIALOG_TITLE}
      body={
        <Box sx={{ textAlign: 'center', maxWidth: 388, mx: 'auto' }}>
          <Typography sx={confirmationBodySx}>{HIDE_QUESTION_DIALOG_BODY}</Typography>
        </Box>
      }
      stayLabel="Cancel"
      confirmLabel="Hide Question"
      confirmTone="primary"
      dialogTestId="hide-question-dialog"
      stayTestId="hide-question-cancel"
      confirmTestId="hide-question-confirm"
    />
  )
}
